import { convertJSONToCSV, downloadCSV } from 'lib/helpers/utility';

const downloadAsCSV = (data, filename) => {
  const csvContent = convertJSONToCSV(data);
  if (csvContent) {
    downloadCSV(csvContent, `${filename}.csv`);
  }
};

export default downloadAsCSV;
